import { HTMLAttributeAnchorTarget, ReactNode } from 'react';
import { Tooltip, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { Link } from 'react-router-dom';
import { TIcon } from '@shared/types';
import { NavItem } from './NavItem';

type TProps = {
  hasAccess: boolean;
  disabledMessage: string;
  to: string;
  target?: Extract<HTMLAttributeAnchorTarget, '_self' | '_blank'>;
  value: string;
  icon: TIcon;
  className?: string;
  children: ReactNode;
};

const useStyles = makeStyles({
  // Fluent's NavItem ships no disabled styling - `disabled` only makes it inert.
  disabled: {
    cursor: 'not-allowed',
    '& button': {
      pointerEvents: 'none',
      color: tokens.colorNeutralForegroundDisabled,
    },
  },
});

const GatedNavLink = ({ hasAccess, disabledMessage, to, target, value, icon, className, children }: TProps) => {
  const classes = useStyles();

  if (!hasAccess)
    return (
      <Tooltip content={disabledMessage} relationship="description" positioning="after" withArrow>
        <div className={mergeClasses(className, classes.disabled)} tabIndex={0} aria-disabled="true">
          <NavItem icon={icon} value={value} disabled>
            {children}
          </NavItem>
        </div>
      </Tooltip>
    );

  return (
    <Link to={to} target={target} className={className}>
      <NavItem icon={icon} value={value}>
        {children}
      </NavItem>
    </Link>
  );
};

export default GatedNavLink;
